export const SHOW_GLOBAL_ERROR = 'SHOW_GLOBAL_ERROR';
export const HIDE_GLOBAL_ERROR = 'HIDE_GLOBAL_ERROR';